import jsonp from "refractor/jsonp";
export default jsonp;